import { render, staticRenderFns } from "./BundleCardsFilters1.vue?vue&type=template&id=1497ff7a&"
import script from "./BundleCardsFilters1.vue?vue&type=script&lang=js&"
export * from "./BundleCardsFilters1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports